import {Events} from '../../@types/wishlist.js';

export class EventApiInstance {
  async postEventsSeenUntil(endpoint: string, maxUnseenOccasionDate: string) {
    try {
      await fetch(endpoint, {
        method: 'POST',
        body: JSON.stringify({
          eventsSeenUntil: maxUnseenOccasionDate
        }),
        headers: {
          'Content-Type': 'application/json',
        },
      });
    } catch (error) {
      console.error('Error creating collection:', error);
    }
  }

  async getEvents(endpoint: string): Promise<Events> {
    const fetchOptions: RequestInit = {
      method: 'GET',
      mode: 'same-origin',
      credentials: 'same-origin',
      cache: 'no-cache',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    if (typeof AbortSignal !== 'undefined' && typeof AbortSignal.timeout === 'function') {
      fetchOptions.signal = AbortSignal.timeout(5000);
    }

    const response = await fetch(endpoint, fetchOptions);

    if (response.status >= 400) {
      throw new Error(`Events API call failed: ${await response.text()}`);
    }

    return response.json();
  }
}

export const eventApi = new EventApiInstance();
